$(document).ready(function() {
    (function initMultiTargetTabs(){

        //initial tab
        var currentTab = $('.nav-link.active');
        toggleFieldsVisibility(currentTab);
        initToggleFieldsEnable();

        //on tab click
        $('.nav-tabs-multiple-target .nav-link').on('click', function(){
            toggleFieldsVisibility($(this));
        });

    })();

    $(function() {
        $('.input-enable-toggle').change(function() {
            toggleFieldsEnable($(this));
        });
    })

});

function toggleFieldsVisibility(tab) {

    var tabTarget = tab.data('lang');
    var currentTab = $('.nav-item.active').removeClass('active');

    if(currentTab.data('') != tabTarget){

        if (tabTarget == 'all') {
            $('.multitab-list .tab-pane').show();
        } else {
            $('.multitab-list .tab-pane').each(function () {
                var tabPaneTarget = $(this).data('lang');

                if(tabPaneTarget != null) {
                    $(this).not('[data-type=global]').hide();
                    if (tabPaneTarget === tabTarget) {
                        $(this).show();
                    }
                }
            });
        }

    }
}


function initToggleFieldsEnable() {
    $(".input-enable-toggle").each(function() {
        toggleFieldsEnable($(this));
    });
}

function toggleFieldsEnable(button) {

    var value = button.data('value');
    var target = button.data('target');

    //ENABLE DISABLE INPUTS
    var allTargets = $('*[data-'+target+'='+value+'] input:not(.input-enable-toggle)');
    if(button.prop('checked')){
        allTargets.prop('disabled', false);
    } else {
        allTargets.prop('disabled', true);
    }

    //ENABLE DISABLE TINYMCE
    for (i=0; i < tinyMCE.editors.length; i++){
        if(tinyMCE.editors[i].id.endsWith(":"+value)){
            if(button.prop('checked')) {
                tinyMCE.editors[i].setMode('design');
            } else {
                tinyMCE.editors[i].setMode('readonly');
            }
        }
    }

}


// WEBPACK FOOTER //
// ./resources/assets/themes/default/js/bootstrap-multiple-target-tabs.js